import React from 'react';
import Grid from '@material-ui/core/Grid';

import KanbanCard from "./KanbanCard";
import KanbanSimpleLogic from "./KanbanSimpleLogic";

import './KanbanTable.css';

class KanbanTable extends React.Component {
    constructor(props) {
        super(props);

        this.select = this.select.bind(this);

        this.state = {
            selection: undefined,
        };

        this.kanbanLogic = new KanbanSimpleLogic();
    }

    componentDidMount() {
        this.getRequirements();
    }

    getRequirements() {
        const request = `/model/Product/${this.props.product}/recursively?collections=requirements,children&status=To do&size(tasks)=>0`;
        this.props.globals.get(encodeURI(request))
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("KanbanTable result:", result);
                    this.setState({requirements: result});
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    select(object) {
        console.log("KanbanTable.select", object);
        this.setState({selection: object});
    }

    render() {
        // const selection = this.state.selection || {};
        const requirements = this.state.requirements;
        // const rowStyle = {
        //     verticalAlign: "top",
        // };

        let columns = this.kanbanLogic.columns;
        let rows = this.kanbanLogic.buildRows(requirements);
        console.log("columns:", columns);
        console.log("rows:", rows);
        return (
            <Grid container direction="column">
                <Grid container direction="row" wrap="nowrap">
                    {
                        columns.map(column =>
                            <Grid item key={column} xs={4}>{column}</Grid>
                        )
                    }
                </Grid>
                {
                    rows.map(row =>
                        <Grid container direction="row" wrap="nowrap" spacing={1}>
                            {
                                Object.keys(columns).map(column =>
                                    <Grid item xs={4}>
                                        {
                                            row[columns[column]] ?
                                                <KanbanCard
                                                    globals={this.props.globals}
                                                    element={row[columns[column]]}
                                                    selection={this.state.selection}
                                                    onSelect={this.select}
                                                /> :
                                                null
                                        }
                                    </Grid>
                                )
                            }
                        </Grid>
                    )
                }
            </Grid>
        );
    }
}

export default KanbanTable;
